import store from '../../store';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import { pathOr } from 'ramda';

export default (params, redirect) =>
  new Promise((resolve, reject) => {
    const { username, password } = params;
    axios
      .post(process.env.VUE_APP_API_AUTHEN_LOCATION + 'tokens', {
        email: username,
        password,
      })
      .then((res) => {
        const token = pathOr(null, ['data', 'data', 'token'], res);
        const user = jwt.decode(token);
        const data = {
          token,
          user,
        };
        store.dispatch('auth/login', data);

        const roles = pathOr([], ['user', 'data', 'roles'], data);
        const startPage = Object.keys(pathOr([], ['state', 'setting', 'authorization', 'startPage'], store));
        const hasValidRole = startPage.some((v) => roles.includes(v));

        if (hasValidRole) {
          if (redirect)
            window.router.push({
              path: redirect,
            });
          else
            window.router.push({
              name: store.state.setting.authorization.startPage[roles[0]],
            });
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
